import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import StudentSidebar from '../StudentSidebar/StudentSidebar';
import { useDispatch, useSelector } from 'react-redux';
import { getStudentApprovedTutorList, getStudentRequestTutorDetail, getStudentRequestTutorList } from '../../../Redux/action/StudentAction';
import Beatloader from '../../../Common/BeatLoader';
import ResponsivePagination from '../../../Common/Pagination';


const host = process.env.REACT_APP_API_SERVER
const StudentRequestForTutor = () => {

    const [showRequestList, setshowRequestList] = useState(true);
    const [showApproveList, setshowApproveList] = useState(false);
    const [StudentTutorRequestDetailsApiData, setModalData] = useState([])

    const handleRequestList = () => {
        setshowRequestList(true);
        setshowApproveList(false);
    }
    const handleApproveList = () => {
        setshowRequestList(false);
        setshowApproveList(true);
    }



    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStudentRequestTutorList())
        dispatch(getStudentApprovedTutorList())

    }, []);
    const handleModalOpen = (data) => {
        setModalData(data)
        // dispatch(getStudentRequestTutorDetail(id))
    }


    const {
        loadingStudentTutorRequestListApi,
        StudentTutorRequestListApiData,
        StudentTutorRequestListApiError,

        loadingStudentApprovedTutorListApi,
        StudentApprovedTutorListApiData,
        StudentApprovedTutorListApiError,


        loadingStudentTutorRequestDetailsApi,
        // StudentTutorRequestDetailsApiData,
        StudentTutorRequestDetailsApiError,


    } = useSelector(state => state?.StudentReducer);


    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!StudentTutorRequestListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(StudentTutorRequestListApiData.slice(start, end));
        setPageCount(Math.ceil(StudentTutorRequestListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, StudentTutorRequestListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };


    const [currentDataApp, setCurrentDataApp] = useState([]);
    const [pageCountApp, setPageCountApp] = useState(0);
    const [currentPageApp, setCurrentPageApp] = useState(1); // ✅ 1-based page index

    useEffect(() => {
        if (!StudentApprovedTutorListApiData) return;

        const start = (currentPageApp - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentDataApp(StudentApprovedTutorListApiData.slice(start, end));
        setPageCountApp(Math.ceil(StudentApprovedTutorListApiData.length / dataPerPage));
    }, [currentPageApp, dataPerPage, StudentApprovedTutorListApiData]);

    const handlePageClickApp = (pageNumber) => {
        setCurrentPageApp(pageNumber);
        window.scrollTo(0, 0);
    };


    return (
        <div>
            <section className="after-header pagination-component">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Request for Tutor
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="study-material">
                                    <div className="row study-material-card-sec">
                                        <div className="col-lg-4 col-md-4 mb-2" onClick={handleRequestList}>
                                            <div className="card" id="add-study-tab">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9">
                                                            <h5 className="mb-0">View Request List</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 mb-2" onClick={handleApproveList}>
                                            <div className="card" id="view-study-tab">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9">
                                                            <h5 className="mb-0">Approved List</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {showRequestList && <div
                                        className="add-study-material-sec mt-5"
                                        id="add-study-tab-pane"

                                    >
                                        <div className="row ">
                                            {loadingStudentTutorRequestListApi ?
                                                <Beatloader />
                                                : <> {StudentTutorRequestListApiData?.length > 0 ?
                                                    <>
                                                        {currentData?.map((data) => (
                                                            <div className="col-lg-6 mt-3 col-md-6">
                                                                <div className="card input-card-form bg-white">
                                                                    <div className="card-body">
                                                                        <div className="row justify-content-center">
                                                                            <div className="col-lg-12 d-flex justify-content-end">
                                                                                {/* <p>{data?.id}</p> */}
                                                                                <p className="mb-0" style={{ fontSize: 13 }}>
                                                                                    <i>{data?.status}</i>
                                                                                </p>
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-4 col-md-4"
                                                                            // style={{ width: "fit-content" }}
                                                                            >
                                                                                <img
                                                                                    onError={(e) => {
                                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                    }}
                                                                                    src={`${host}${data?.tutor?.profile_img}`}
                                                                                    className="img-fluid rounded-circle"
                                                                                    style={{ height: "7.6rem", width: "auto" }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-8 col-md-8"
                                                                                style={{ width: "fit-content" }}
                                                                            >
                                                                                <h5 className="mb-0 text-dark">{data?.tutor?.name}</h5>
                                                                                <p className="mb-0">{data?.tutor?.tutordetails?.specialization}</p>
                                                                                {data?.tutor?.tutordetails?.experience && <p className="mb-0">{data?.tutor?.tutordetails?.experience} Year experience</p>}
                                                                                <div className="rating">
                                                                                    {Array.from({ length: 5 }, (_, index) => {
                                                                                        const averageRating = parseFloat(data?.tutor?.avarageRating || "0"); // Convert to number
                                                                                        if (index < Math.floor(averageRating)) {
                                                                                            return <i key={index} className="fas fa-star filled" />;
                                                                                        } else if (index < averageRating) {
                                                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                                        } else {
                                                                                            return <i key={index} className="fas fa-star" />;
                                                                                        }
                                                                                    })}
                                                                                    <span>
                                                                                        {data?.tutor?.avarageRating} <span className="text-primary">({data?.tutor?.total_rating_count} Ratings)</span>
                                                                                    </span>
                                                                                </div>
                                                                                {data?.status == 'APPROVED' ?
                                                                                    <Link to={`/student/course-details/${btoa(data?.id)}`} state={{ data: data }}>
                                                                                        <button className="btn btn-primary py-1 w-100 mt-1">
                                                                                            {data?.isPurchased ? 'View Details' : 'Book Now'}
                                                                                        </button>
                                                                                    </Link>
                                                                                    :
                                                                                    <button
                                                                                        onClick={() => { handleModalOpen(data) }}
                                                                                        className="btn btn-primary py-1 w-100 mt-1"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#pendingModal"
                                                                                    >
                                                                                        View Request Details
                                                                                    </button>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}


                                                        {pageCount > 1 && (
                                                            <ResponsivePagination
                                                                pageCount={pageCount}
                                                                currentPage={currentPage}
                                                                handlePageClick={handlePageClick}
                                                            />
                                                        )}
                                                    </>
                                                    :
                                                    <div className='no-data-img'>
                                                        <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                    </div>
                                                }
                                                </>}
                                        </div>
                                    </div>}
                                    {showApproveList && <div
                                        className="view-study-material-sec mt-5"
                                        id="view-study-tab-pane"

                                    >
                                        <div className="row">
                                            {loadingStudentApprovedTutorListApi ?
                                                <Beatloader />
                                                : <> {StudentApprovedTutorListApiData?.length > 0 ?
                                                    <>
                                                        {currentDataApp?.map((data) => (
                                                            <div className="col-lg-6 mt-3 col-md-6">
                                                                <div className="card input-card-form bg-white">
                                                                    <div className="card-body">
                                                                        <div className="row justify-content-center">
                                                                            <div className="col-lg-12 d-flex justify-content-end">
                                                                                <p className="mb-0" style={{ fontSize: 13 }}>
                                                                                    <i>{data?.status}</i>
                                                                                </p>
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-4 col-md-4"
                                                                            // style={{ width: "fit-content" }}
                                                                            >
                                                                                <img
                                                                                    src={`${host}${data?.tutor?.profile_img}`}
                                                                                    className="img-fluid rounded-circle"
                                                                                    style={{ height: "7.6rem", width: "auto" }}
                                                                                    onError={(e) => {
                                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-8 col-md-8"
                                                                                style={{ width: "fit-content" }}
                                                                            >
                                                                                <h5 className="mb-0 text-dark">{data?.tutor?.name}</h5>
                                                                                <p className="mb-0">{data?.tutor?.tutordetails?.specialization}</p>
                                                                                {data?.tutor?.tutordetails?.experience && <p className="mb-0">{data?.tutor?.tutordetails?.experience} Year experience</p>}
                                                                                <div className="rating">
                                                                                    {Array.from({ length: 5 }, (_, index) => {
                                                                                        const averageRating = parseFloat(data?.tutor?.avarageRating || "0"); // Convert to number
                                                                                        if (index < Math.floor(averageRating)) {
                                                                                            return <i key={index} className="fas fa-star filled" />;
                                                                                        } else if (index < averageRating) {
                                                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                                        } else {
                                                                                            return <i key={index} className="fas fa-star" />;
                                                                                        }
                                                                                    })}
                                                                                    <span>
                                                                                        {data?.tutor?.avarageRating} <span className="text-primary">({data?.tutor?.total_rating_count} Ratings)</span>
                                                                                    </span>
                                                                                </div>
                                                                                <Link to={`/student/course-details/${btoa(data?.id)}`}>
                                                                                    <button className="btn btn-primary py-1 w-100 mt-1">
                                                                                    {data?.isPurchased ? 'View Details' : 'Book Now'}
                                                                                    </button>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {pageCountApp > 1 && (
                                                            <ResponsivePagination
                                                                pageCount={pageCountApp}
                                                                currentPage={currentPageApp}
                                                                handlePageClick={handlePageClickApp}
                                                            />
                                                        )}
                                                    </> :
                                                    <div className='no-data-img'>
                                                        <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                    </div>
                                                }
                                                </>}
                                        </div>
                                    </div>}
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Pending Modal */}
                <div
                    className="modal fade tutor-details-modal"
                    id="pendingModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        {loadingStudentTutorRequestDetailsApi ?
                            <Beatloader /> :
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        View Request Detail
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-2">
                                        <div className="col-lg-12 d-flex justify-content-end">
                                            <p className="mb-0 text-primary" style={{ fontSize: 13 }}>
                                                <i>
                                                    <i className="bi bi-exclamation-circle me-2" />
                                                    {StudentTutorRequestDetailsApiData?.status}
                                                </i>
                                            </p>
                                        </div>
                                        <div className="col-lg-4 col-md-4"
                                        // style={{ width: "fit-content" }}
                                        >
                                            <img
                                                src={`${host}${StudentTutorRequestDetailsApiData?.tutor?.profile_img}`}
                                                className="img-fluid rounded-circle"
                                                style={{ height: "7.6rem", width: "auto" }}
                                                onError={(e) => {
                                                    e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                }}
                                            />
                                        </div>
                                        <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                            <h5 className="mb-0">Name : {StudentTutorRequestDetailsApiData?.tutor?.name}</h5>
                                            <p className="mb-0">{StudentTutorRequestDetailsApiData?.tutor?.tutordetails?.specialization}</p>
                                            <div className="rating">
                                                {Array.from({ length: 5 }, (_, index) => {
                                                    const averageRating = parseFloat(StudentTutorRequestDetailsApiData?.tutor?.avarageRating || "0"); // Convert to number
                                                    if (index < Math.floor(averageRating)) {
                                                        return <i key={index} className="fas fa-star filled" />;
                                                    } else if (index < averageRating) {
                                                        return <i key={index} className="fas fa-star-half-alt filled" />;
                                                    } else {
                                                        return <i key={index} className="fas fa-star" />;
                                                    }
                                                })}
                                                <span>
                                                    {StudentTutorRequestDetailsApiData?.tutor?.total_rating_count} <span className="text-primary">({StudentTutorRequestDetailsApiData?.tutor?.total_rating_count} Ratings)</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 mb-5">
                                        <div className="col-lg-6">
                                            <p className="mb-0">Class/Grade/General</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.reqCategory?.is_other ? StudentTutorRequestDetailsApiData?.reqCategory?.other_name : StudentTutorRequestDetailsApiData?.reqCategory?.name}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">Subject</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.reqSubCategory?.is_other ? StudentTutorRequestDetailsApiData?.reqSubCategory?.other_name : StudentTutorRequestDetailsApiData?.reqCategory?.name}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">Module</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.reqChildSubCategory?.is_other ? StudentTutorRequestDetailsApiData?.reqChildSubCategory?.other_name : StudentTutorRequestDetailsApiData?.reqCategory?.name}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">Created At</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.createdAt}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">Start Date</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.start_date}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">End Date</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.end_date}</h6>
                                        </div>
                                        <div className="col-lg-6">
                                            <p className="mb-0">Timing</p>
                                            <h6>{StudentTutorRequestDetailsApiData?.time_slot?.formated_start_end_time} ({StudentTutorRequestDetailsApiData?.time_slot?.timeZoneAbb})</h6>
                                        </div>
                                        {StudentTutorRequestDetailsApiData?.rejected_reason &&
                                            <div className="col-lg-12">
                                                <p className="mb-0">Rejection Reason</p>
                                                <h6>{StudentTutorRequestDetailsApiData?.rejected_reason}</h6>
                                            </div>}
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentRequestForTutor